const fromQueryPlacePredictionsToPlacePredictions = (data)=>{
    if (!data) {
        return null;
    }
    return data.map(({ id , locality , sublocality  })=>({
            id,
            locality,
            sublocality: sublocality !== null && sublocality !== void 0 ? sublocality : undefined
        })
    );
};
var fromQueryPlacePredictionsToPlacePredictions$1 = fromQueryPlacePredictionsToPlacePredictions;

export { fromQueryPlacePredictionsToPlacePredictions$1 as default };
//# sourceMappingURL=fromQueryPlacePredictionsToPlacePredictions.js.map
